import PropTypes from 'prop-types'
import React from 'react'

import Box from '@mui/material/Box'

const SummaryBackTo = ({ onClick, title }) => (
  <Box className="search-control_summary">
    <Box className="search-control_summary-action" display="inline" onClick={onClick}>
      <i className="icon back-arrow-icon" />
      {title}
    </Box>
  </Box>
)

SummaryBackTo.propTypes = {
  onClick: PropTypes.func,
  title: PropTypes.string,
}

export default SummaryBackTo
